import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select } from '@mui/material';
import { colorPrimary } from '../../Styles/Colors';

export default function Dropdown({ style = {}, textStyle = {}, label = "Select", options = [], value, onChange, ...rest }) {
 
  const handleChange = (event) => {
    if (onChange) onChange(event);
  };
 
  const mergedSx = {
    "& .MuiInputLabel-root": {
      color: textStyle.color || colorPrimary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: textStyle.color || colorPrimary,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: style.backgroundColor || '#fff',
      borderRadius: style.borderRadius || '8px',
      "& fieldset": {
        borderColor: style.borderColor || colorPrimary,
      },
      "&:hover fieldset": {
        borderColor: style.borderColor || colorPrimary,
      },
      "&.Mui-focused fieldset": {
        borderColor: style.borderColor || colorPrimary,
        borderWidth: style.borderWidth || "2px",
      },
 
      height: style.height || '40px',
    },
  };
 
  return (
    <Box
      sx={{
        ...mergedSx,
        maxWidth: style.maxWidth || '100%',
        width: style.width || '100%',
      }}
      {...rest}
    >
      <FormControl fullWidth style={{ height: style.height || '40px' }}>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="dropdown-label"
          id="dropdown-select"
          value={value}
          label={label}
          onChange={handleChange}
          sx={{
            color: textStyle.color || colorPrimary,
            ...('fontSize' in style ? { fontSize: style.fontSize } : {}),
            height: style.height || '40px',
            width: style.width || '100%',
          }}
        >
          {options && options.length > 0
            ? options.map((option, idx) => (
                <MenuItem key={option.value ?? option} value={option.value ?? option}>
                  {option.label ?? option}
                </MenuItem>
              ))
            : [
                <MenuItem key={10} value={10}>Ten</MenuItem>,
                <MenuItem key={20} value={20}>Twenty</MenuItem>,
                <MenuItem key={30} value={30}>Thirty</MenuItem>,
              ]}
        </Select>
      </FormControl>
    </Box>
  );
}
